// Sidebar.js
import React, { useRef, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import '../pages/Dashboard.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const navRef = useRef(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (navRef.current && window.innerWidth <= 768) {
        const hasOverflow = navRef.current.scrollWidth > navRef.current.clientWidth;
        setShowScrollIndicator(hasOverflow);
      } else {
        setShowScrollIndicator(false);
      }
    };

    checkScroll();
    
    const resizeObserver = new ResizeObserver(checkScroll);
    if (navRef.current) {
      resizeObserver.observe(navRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    sessionStorage.clear();
    navigate('/login');
  };

  return (
    <div className="sidebar" ref={sidebarRef}>
      <div className="sidebar-header">
        <h2 className="logo">Shree Balaji Traders</h2>
        <div className="logo-subtitle">Inventory Management</div>
      </div>
      <nav className="sidebar-nav" ref={navRef}>
        <NavLink to="/dashboard" className="nav-link" activeClassName="active">
          <i className="fas fa-tachometer-alt"></i> Dashboard
        </NavLink>
        <NavLink to="/signup" className="nav-link" activeClassName="active">
          <i className="fas fa-user-plus"></i> Create User
        </NavLink>
        <NavLink to="/admins" className="nav-link" activeClassName="active">
          <i className="fas fa-users-cog"></i> Admin List
        </NavLink>

        <div className="nav-separator" />

        <NavLink to="/add-product" className="nav-link" activeClassName="active">
          <i className="fas fa-plus-circle"></i> Product Create
        </NavLink>
        <NavLink to="/product-list" className="nav-link" activeClassName="active">
          <i className="fas fa-boxes"></i> Product List
        </NavLink>
 <NavLink to="/product-display" className="nav-link" activeClassName="active">
          <i className="fas fa-eye"></i> Product Display
        </NavLink>
        <NavLink to="/purchase" className="nav-link" activeClassName="active">
          <i className="fas fa-cart-plus"></i> Purchase
        </NavLink>
        <NavLink to="/purchase-report" className="nav-link" activeClassName="active">
          <i className="fas fa-file-invoice-dollar"></i> Purchase Report
        </NavLink>
        <NavLink to="/reduce-stock" className="nav-link" activeClassName="active">
          <i className="fas fa-cart-arrow-down"></i> Sale
        </NavLink>
        <NavLink to="/sales-reports" className="nav-link" activeClassName="active">
          <i className="fas fa-chart-bar"></i> Sale Report
        </NavLink>
        <NavLink to="/return" className="nav-link" activeClassName="active">
          <i className="fas fa-undo"></i> Sale Return
        </NavLink>
        <NavLink to="/return-report" className="nav-link" activeClassName="active">
          <i className="fas fa-file-excel"></i> Sale Return Report
        </NavLink>
<NavLink to="/adjustment" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          <i className="fas fa-sliders-h"></i> Adjustment
        </NavLink>
        <NavLink to="/adjustment-report" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
          <i className="fas fa-clipboard-list"></i> Adjustment Report
        </NavLink>
  <NavLink to="/stock" className="nav-link" activeClassName="active">
          <i className="fas fa-warehouse"></i> Stock
        </NavLink>
      </nav>
      {showScrollIndicator && (
        <div className="scroll-indicator">
          <i className="fas fa-chevron-right"></i>
        </div>
      )}
      <button onClick={handleLogout} className="logout-btn">
        <i className="fas fa-sign-out-alt"></i> Logout
      </button>
    </div>
  );
};

export default Sidebar;
